import { render, staticRenderFns } from "./VenueAnalysisDetails.vue?vue&type=template&id=1f388d8b&"
import script from "./VenueAnalysisDetails.vue?vue&type=script&lang=js&"
export * from "./VenueAnalysisDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports